import gql from 'graphql-tag';

// QUERIES

// Get the active and current review for this booklet from a company
const getCompanyBookletReviewQuery = gql`
  query ($companyId: ObjectId!, $bookletId: ObjectId!) {
    bookletCompanyReview: bookletCompanyReview(companyId: $companyId, bookletId: $bookletId) {
      _id
      bookletId
      sentToEmails
      coupons {
        _id
      }
      comment
      approvedDate
      approvedByAdmin
      messageToCompany
      isActive
      sentDate
    }
  }
`;

// Get ALL events pertaining to this booklet for this company
const getCompanyBookletReviewsQuery = gql`
  query ($companyId: ObjectId!, $bookletId: ObjectId!) {
    bookletCompanyReviews: bookletCompanyReviews(companyId: $companyId, bookletId: $bookletId) {
      _id
      bookletId
      company {
        name
      }
      sentToEmails
      coupons {
        _id
      }
      comment
      approvedDate
      approvedByAdmin
      messageToCompany
      isActive
      sentDate
    }
  }
`;

const companyReviewByTokenQuery = gql`query BookletCompanyReviewByToken($token: String!) {
  bookletCompanyReviewByToken(token: $token) {
    _id
    bookletId
    company {
      _id
      name
      logoURL
      websiteURL
      typeId
      companyCategoryId
      phone
      visitAddress {
        streetAddress
        city
      }
    }
    coupons {
      _id
      discount 
      description
      smallTitle
      productLink
      terms
      imageURL
      code
      codeType
      position
      assessment {
        rating
        motivation
        expectedEffect
        profitability
        targetGroupAdaptation
        shouldShowAssessment
      }
    }
    sentDate
    comment
    approvedDate
    isActive
  }
}`;

const companyStatsByTokenQuery = gql`
query($token: String!) {
  companyStatsByToken(token: $token) {
    booklet {
      _id
      validFrom
      validTo
      colorLeft
      colorRight
      logoURL
      title
      subtitle
      colorFont
    }
    company {
      _id
      name
      logoURL
      websiteURL
      typeId
      companyCategoryId
      phone
      visitAddress {
        streetAddress
        city
      }
    }
    coupons {
      _id
      discount 
      description
      smallTitle
      productLink
      terms
      imageURL
      position
    }
    couponUsages {
      couponId
      amount
    }
  }
}`;

// MUTATIONS

const addBookletCompanyReviewMutation = gql`
  mutation($bookletId: ObjectId!, $companyId: ObjectId!, $couponIds: [ObjectId!]!, $shouldSendMail: Boolean, $sentToEmails: [String!], $messageToCompany: String, $replyTo: String) {
    createBookletCompanyReview(
      bookletId: $bookletId
      companyId: $companyId
      couponIds: $couponIds
      shouldSendMail: $shouldSendMail
      sentToEmails: $sentToEmails
      messageToCompany: $messageToCompany
      replyTo: $replyTo
    ) {
      _id
      sentToEmails
    }
  }

`;

const updateBookletCompanyReviewMutation = gql`
  mutation(
    $_id: ObjectId!
    $bookletId: ObjectId
    $token: String
    $sentToEmails: [String]
    $sentDate: DateTime
    $company: CompanyInput
    $coupons: [CouponInput]
    $comment: String
    $approvedDate: DateTime  
    $approvedByAdmin: String
    $messageToCompany: String
    $isActive: Boolean
    ) {
      updateBookletCompanyReview(
        _id: $_id,
        bookletId: $bookletId,
        token: $token,
        sentToEmails: $sentToEmails,
        sentDate: $sentDate,
        company: $company,
        coupons: $coupons,
        comment: $comment,
        approvedDate: $approvedDate
        approvedByAdmin: $approvedByAdmin
        messageToCompany: $messageToCompany
        isActive: $isActive
      ) {
        _id
      }
  }
`;
const updateBookletCompanyReviewWithTokenMutation = gql`
  mutation(
    $token: String!
    $comment: String
    $approvedDate: DateTime
    ) {
      updateBookletCompanyReviewWithToken(
        token: $token,
        comment: $comment,
        approvedDate: $approvedDate
      ) {
        _id
      }
  }
`;

export {
  getCompanyBookletReviewQuery,
  getCompanyBookletReviewsQuery,
  companyReviewByTokenQuery,
  companyStatsByTokenQuery,
  addBookletCompanyReviewMutation,
  updateBookletCompanyReviewMutation,
  updateBookletCompanyReviewWithTokenMutation
}
